import { useSnapshot } from 'valtio'
import uiState from '../data'
import { AnimatePresence, motion } from 'framer-motion'
import { isMobile } from 'react-device-detect'
import { useState } from 'react'
import { windowSizeState } from '../utils/windowSize'

const LetterPage = ({ event }) => {
  const { visible, data } = useSnapshot(uiState[event])
  const [isEnterHover, setIsEnterHover] = useState(false)
  const [tipPosition, setTipPosition] = useState({ x: 0, y: 0 })
  const [showHoverTip, setShowHoverTip] = useState(false)
  const { mobileMode } = useSnapshot(windowSizeState)

  const goInfoPage = () => {
    uiState.infoPage.visible = true
    uiState[event].visible = false
  }
  return (
    <>
      <AnimatePresence>
        {visible && mobileMode && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.8 }}
            className='screen-setting overflow-hidden fixed top-0 left-0 bg-mainYellow-100'
          >
            <div className='w-[80%] h-[75%]  absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex flex-col items-end portraitBigPh:h-[70%] landscapePhone:h-[50%]'>
              <div
                className={`w-full h-full px-[10px]  whitespace-pre-wrap overflow-y-scroll relative letterScroll   text-[17px]  NotoSerifR  `}
              >
                <div className='mb-8 text-justify '>{data.zh}</div>
                <div className=' text-start'>{data.en}</div>
              </div>
            </div>
            <div className='absolute bottom-[1.5%] right-[8%]'>
              <div className='w-[80px]'>
                <img
                  src={
                    isEnterHover && !isMobile
                      ? '../startMedia/closeletter_hover.png'
                      : '../startMedia/closeletter.png'
                  }
                  alt='前往info page'
                  className='  w-full object-contain'
                  onClick={goInfoPage}
                  onMouseEnter={() => {
                    setIsEnterHover(true)
                  }}
                  onMouseLeave={() => {
                    setIsEnterHover(false)
                  }}
                />
                <div className='  NotoSerifM  rotate-[12deg] text-[15px] -translate-x-[12px] w-[150px] '>
                  進入展覽介紹
                </div>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
      <AnimatePresence>
        {visible && !mobileMode && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.8 }}
            className='screen-setting overflow-hidden fixed top-0 left-0 bg-mainYellow-100'
          >
            {showHoverTip && !isMobile && (
              <motion.div
                className=' fixed top-0 left-0 tracking-[1px] z-50  NotoSerifM flex'
                animate={{ x: tipPosition.x - 28, y: tipPosition.y - 35 }}
                transition={{ duration: 0 }}
              >
                <div className='mr-[5px]'>Enter</div>
                <img
                  src='../startMedia/right-arrow.png'
                  alt=''
                  className='w-[15px] object-contain'
                />
              </motion.div>
            )}
            <div
              className=' absolute right-[8%] bottom-[8%] w-[6%] smallLaptop:w-[8%] landscapePad:w-[8%] '
              onMouseMove={(e) => {
                setTipPosition({ x: e.clientX, y: e.clientY })
              }}
              onMouseEnter={() => {
                setShowHoverTip(true)
              }}
              onMouseLeave={() => {
                setShowHoverTip(false)
              }}
            >
              <img
                src={
                  isEnterHover && !isMobile
                    ? '../startMedia/closeletter_hover.png'
                    : '../startMedia/closeletter.png'
                }
                alt='前往info page'
                className='w-full cursor-pointer'
                onClick={goInfoPage}
                onMouseEnter={() => {
                  setIsEnterHover(true)
                }}
                onMouseLeave={() => {
                  setIsEnterHover(false)
                }}
              />
              <div className=' NotoSerifM rotate-[12deg] text-[17px] -translate-x-[52%] bottom-0 translate-y-[80%]  w-[110px] absolute left-1/2 '>
                進入展覽介紹
              </div>
            </div>
            <div className='w-[60%] h-[85%]  absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex flex-col items-end'>
              <div
                className={`w-[calc(100%-50px)] pl-[30px] pr-[50px] whitespace-pre-wrap NotoSerifR overflow-y-scroll relative  letterScroll  text-justify text-[17px]`}
              >
                <div className='mb-8 tracking-[3px] '>{data.zh}</div>
                <div className='tracking-[0px]  '>{data.en}</div>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  )
}

export default LetterPage
